import { createTeamResourceContext } from './createTeamResourceContext'
import useRegistryCredentialsResources from '../shared/resources/api/v1/admin/docker/useRegistryCredentialsResources'

const { Provider: RegistryCredentialsProvider, useHook: useRegistryCredentials } = createTeamResourceContext({
  name: 'RegistryCredentials',
  useResources: useRegistryCredentialsResources,
  responseKey: 'registryCredentials',
  lookups: [{ key: 'registryCredentialsById', field: 'id' }],
})

export { RegistryCredentialsProvider, useRegistryCredentials }
